import React, { useCallback } from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import { FormattedMessage, useIntl } from 'react-intl';
import { css } from '@emotion/css';
import ControlledExpander from '../commons/ControlledExpander';
import useNavigateToSpecifiedRoute from '../../hooks/useNavigateToSpecifiedRoute';
import { FAQ_PAGE_PATH } from '../../config/navigationalRoutes';

const FrequentlyAskedQuestions = () => {
  const { formatMessage } = useIntl();
  const { navigateToSpecifiedRoute } = useNavigateToSpecifiedRoute();
  const onFAQClick = useCallback(() => {
    navigateToSpecifiedRoute(FAQ_PAGE_PATH);
  }, [navigateToSpecifiedRoute]);

  return (
    <Column
      type="fill"
      backgroundColor="#055D7B"
      spacingInset="large"
      spacing="medium"
      width="100%">
      <Row>
        <Text type="h600" color="inverted" id="faq">
          <FormattedMessage id="home_page.faq_section.header" />
        </Text>
      </Row>
      <div className="faqDrillDown">
        <ControlledExpander
          title={formatMessage({
            id: 'home_page.faq_section.drilldown.q1.title',
          })}
          type="list">
          <Text color="inverted">
            <FormattedMessage id="faq_page.all_faqs.a1.legend" />
            <ul>
              <li>
                <FormattedMessage id="faq_page.all_faqs.a1.p1" />
              </li>
              <li>
                <FormattedMessage id="faq_page.all_faqs.a1.p2" />
              </li>
              <li>
                <FormattedMessage id="faq_page.all_faqs.a1.p3" />
              </li>
            </ul>
          </Text>
        </ControlledExpander>
      </div>
      <div className="faqDrillDown">
        <ControlledExpander
          title={formatMessage({
            id: 'home_page.faq_section.drilldown.q3.title',
          })}
          type="list">
          <>
            <Text color="inverted">
              <FormattedMessage
                id="faq_page.all_faqs.a3.p1"
                values={{
                  link: (
                    <a
                      href="https://carrierlogistics.integ.amazon.com/privacy-notice"
                      target="_blank"
                      rel="noreferrer">
                      <FormattedMessage id="faq_page.all_faqs.a3.link" />
                    </a>
                  ),
                }}
              />
            </Text>
            <br />
            <Text color="inverted">
              <FormattedMessage
                id="faq_page.all_faqs.a3.p2"
                values={{
                  link: (
                    <a
                      href="https://carrierlogistics.integ.amazon.com/terms"
                      target="_blank"
                      rel="noreferrer">
                      <FormattedMessage id="faq_page.all_faqs.a3.conditions" />
                    </a>
                  ),
                }}
              />
            </Text>
          </>
        </ControlledExpander>
      </div>
      <div className="faqDrillDown">
        <ControlledExpander
          title={formatMessage({
            id: 'faq_page.all_faqs.q4',
          })}
          type="list">
          <Text type="b300" color="inverted">
            <FormattedMessage id="faq_page.all_faqs.a4" />
          </Text>
        </ControlledExpander>
      </div>
      <Row spacingInset="small small large xsmall">
        <Button
          type="secondary"
          className={css`
            & {
              background-color: white;
              border-radius: 4px;
              color: #055d7b;
              font-weight: bold;
            }
            &:hover {
              background-color: #eee;
              color: #055d7b;
            }
          `}
          onClick={onFAQClick}>
          <div>
            <FormattedMessage id="home_page.faq_section.see_all_faqs_button" />
          </div>
        </Button>
      </Row>
    </Column>
  );
};

export default FrequentlyAskedQuestions;
